var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.595 31.5c1.153 2-.295 4.5-2.599 4.5H5.003c-2.308 0-3.75-2.503-2.598-4.5L17.4 5.5c1.155-2.001 4.045-1.998 5.198 0l14.996 26zM20 26.126a2.875 2.875 0 100 5.75 2.875 2.875 0 000-5.75zm-2.73-10.334l.464 8.5a.75.75 0 00.749.709h3.034a.75.75 0 00.749-.71l.464-8.5a.75.75 0 00-.75-.79h-3.96a.75.75 0 00-.75.79z"
  })));
}

export default SvgWarning;